export function getFeishuPlatform(query) {
    return (query && (query.platform || query.platfrom)) || '';
}
function getQueryValueFromUrl(url, key) {
    if (!url || !key)
        return '';
    const queryIndex = url.indexOf('?');
    if (queryIndex === -1)
        return '';
    const hashIndex = url.indexOf('#');
    const search = url
        .slice(queryIndex + 1, hashIndex > -1 ? hashIndex : undefined)
        .split('&');
    for (let i = 0; i < search.length; i += 1) {
        const item = search[i];
        if (!item)
            continue;
        const equalIndex = item.indexOf('=');
        const itemKey = equalIndex > -1 ? item.slice(0, equalIndex) : item;
        if (itemKey === key) {
            const value = equalIndex > -1 ? item.slice(equalIndex + 1) : '';
            return decodeURIComponent(value);
        }
    }
    return '';
}
function getStateValue(query, key) {
    if (!query || !query.state)
        return '';
    let state = query.state;
    try {
        state = decodeURIComponent(state);
    }
    catch (e) {
        state = query.state;
    }
    return getQueryValueFromUrl(state, key);
}
export function getFeishuCorpId(query) {
    return (query && query.corpId) || getStateValue(query, 'corpId') || (query && query.state) || '';
}
export function getFeishuAppId(query, configAppId) {
    return (query && query.appId) || getStateValue(query, 'appId') || configAppId;
}
export function hasFeishuEntryParams(query) {
    return !!(query && (query.isScan || query.code || isFeishuWorkPlatform(query)));
}
export function isFeishuWorkPlatform(query) {
    return getFeishuPlatform(query) === 'feiShuWork';
}
export function shouldUseFeishuOAuthRedirect(query) {
    return getFeishuPlatform(query) === 'feishu' && !!(query && query.lk_jump_to_browser);
}
export function buildFeishuAuthState(href, corpId, appId) {
    const queryIndex = href.indexOf('?');
    const hashIndex = href.indexOf('#');
    const search = queryIndex > -1
        ? href.slice(queryIndex + 1, hashIndex > -1 ? hashIndex : undefined).split('&')
        : [];
    const params = [`corpId=${corpId}`, `appId=${appId}`];
    search.forEach((item) => {
        if (!item)
            return;
        const key = item.split('=')[0];
        if (key === 'corpId'
            || key === 'appId'
            || key === 'code'
            || key === 'state'
            || key === 'platform'
            || key === 'platfrom'
            || key === 'lk_jump_to_browser')
            return;
        params.push(item);
    });
    const hash = hashIndex > -1 ? href.slice(hashIndex) : '';
    return `?${params.join('&')}${hash}`;
}
export function buildFeishuAuthRedirectUrl(href, appId, corpId) {
    const origin = href.split('?')[0].split('#')[0];
    const state = buildFeishuAuthState(href, corpId, appId);
    // if (appId === 'cli_a250830bf920500d') {
    return `https://accounts.feishu.cn/accounts/auth_login/oauth2/authorize?client_id=${appId}&redirect_uri=${encodeURIComponent(origin)}&response_type=code&state=${encodeURIComponent(corpId)}`;
    // }
    // return `https://accounts.feishu.cn/open-apis/authen/v1/index?redirect_uri=${encodeURIComponent(origin)}&app_id=${appId}&state=${encodeURIComponent(state)}`;
}
function getHrefOrigin(href) {
    const protocolIndex = href.indexOf('://');
    if (protocolIndex === -1)
        return href.split('?')[0].split('#')[0];
    const pathIndex = href.indexOf('/', protocolIndex + 3);
    if (pathIndex === -1)
        return href.split('?')[0].split('#')[0];
    return href.slice(0, pathIndex);
}
function normalizePostLoginState(state) {
    let nextState = state.replace(/([?&])id=/, '$1objectId=');
    nextState = nextState.replace(/([?&])isScan=true(&?)/g, (_matched, prefix, suffix) => {
        if (prefix === '?' && suffix)
            return '?';
        if (suffix)
            return prefix;
        return '';
    });
    if (nextState.indexOf('workflowInstanceId') > -1 && nextState.indexOf('isWorkFlow=') === -1) {
        nextState = `${nextState}&isWorkFlow=true`;
    }
    return nextState.replace('?&', '?').replace('&&', '&');
}
export function buildFeishuPostLoginUrl(href, query, configAppId) {
    if (!query || !query.code)
        return '';
    let state = query.state || '';
    try {
        state = decodeURIComponent(state);
    }
    catch (e) {
        state = query.state || '';
    }
    if (!state || state.charAt(0) !== '?') {
        return getHrefOrigin(href);
    }
    const baseUrl = href.split('?')[0].split('#')[0];
    const appId = getFeishuAppId(query, configAppId);
    const corpId = getFeishuCorpId(query);
    let nextState = normalizePostLoginState(state);
    if (nextState.indexOf('corpId=') === -1 && corpId) {
        nextState = `?corpId=${corpId}&appId=${appId}${nextState.replace('?', '&')}`;
    }
    return `${baseUrl}${nextState}`;
}
